/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import DisableAccountForm from './DisableAccountForm/DisableAccountForm';
import DisableAccountSuccess from './DisableAccountSuccess/DisableAccountSuccess';
import DisableAccountError from './DisableAccountError/DisableAccountError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
  accountStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class DisableAccount extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, accountStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const fields: Array<Object> = [
      {
        name: 'disableAccountForm',
        label: t('general:actions.disable_trading_account'),
        title: 'Disable Account',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_disabling'),
            rules: 'required|string',
            value: '',
            type: 'select',
            options: [
              {
                id: 1,
                label: t('general:reasons.options.account_no_longer_in_use'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        if (!accountStore.details) {
          accountStore.loadDetails(currentAccountDetails.id);
        }
      },
      onSuccess(data: Object) {
        const { reason }: Object = data.values().disableAccountForm;

        actionDrawerStore.enableDisableAccount(currentAccountDetails.id, {
          is_enabled: false,
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'Disable Account',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.disable_trading_account')} />
          <DisableAccountError currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.disabled}`}>
          <ActionDrawerHeader title={t('general:actions.disable_trading_account')} />
          <DisableAccountSuccess currentAccountDetails={currentAccountDetails} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.disable_trading_account')} />
        <DisableAccountForm
          currentAccountDetails={currentAccountDetails}
          form={this.createForm()}
        />
      </div>
    );
  }
}
